import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, Button } from "@mui/material";
import { M, TYPE_LABELS, summaryLines } from "./marketplaceTokens";

export default function MarketplaceDetail({ listing, has, importing, onAdd, onClose }) {
  if (!listing) return null;
  const lines = summaryLines(listing.itemType, listing.contentSummary);

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ fontSize: "11px", fontWeight: 700, letterSpacing: ".05em", textTransform: "uppercase", color: M.ink3 }}>{TYPE_LABELS[listing.itemType] || listing.itemType}</Box>
        {listing.title}
        <Box sx={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap", mt: "6px" }}>
          {listing.category && <Box component="span" sx={{ fontSize: "11.5px", fontWeight: 700, px: "8px", py: "2px", borderRadius: "999px", bgcolor: M.surface2, color: M.ink2 }}>{listing.category}</Box>}
          {listing.sourceContentVersion != null && <Box component="span" sx={{ fontSize: "11.5px", fontWeight: 700, px: "8px", py: "2px", borderRadius: "999px", bgcolor: M.surface2, color: M.ink2 }}>v{listing.sourceContentVersion}</Box>}
          {has && <Box component="span" sx={{ fontSize: "11.5px", fontWeight: 700, px: "8px", py: "2px", borderRadius: "999px", bgcolor: M.successBg, color: M.success }}>In my bank</Box>}
          {has && listing.sourceContentVersion > listing.importedAtVersion && (
            <Box component="span" sx={{ fontSize: "11.5px", fontWeight: 700, px: "8px", py: "2px", borderRadius: "999px", bgcolor: M.warnBg, color: M.warn }}>Update available</Box>
          )}
          {listing.updatedAt && <Typography sx={{ fontSize: "12.5px", color: M.ink3 }}>Updated {new Date(listing.updatedAt).toLocaleDateString()}</Typography>}
        </Box>
      </DialogTitle>
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        {listing.description && <Typography sx={{ fontSize: "15px", color: M.ink2, lineHeight: 1.55 }}>{listing.description}</Typography>}

        <Box>
          <Typography sx={{ fontSize: "10px", fontWeight: 700, letterSpacing: ".025em", textTransform: "uppercase", color: M.ink3, mb: "8px" }}>What's included</Typography>
          <Box sx={{ border: `1px solid ${M.line}`, borderRadius: "10px", overflow: "hidden" }}>
            {lines.length === 0 ? (
              <Box sx={{ p: "16px", fontSize: "13.5px", color: M.ink3 }}>No summary available.</Box>
            ) : lines.map((line, i) => (
              <Box key={line} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "12px", p: "12px 16px", borderTop: i ? `1px solid ${M.line}` : "none" }}>
                <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>{line}</Typography>
                <Box sx={{ color: M.ink4, fontSize: "12px" }}>🔒</Box>
              </Box>
            ))}
          </Box>
        </Box>

        <Box sx={{ display: "grid", gridTemplateColumns: "20px minmax(0,1fr)", gap: "10px", p: "12px 14px", borderRadius: "10px", bgcolor: M.surface2, fontSize: "13.5px", lineHeight: 1.45 }}>
          <Box sx={{ color: M.ink3 }}>🔒</Box>
          <span>Full contents unlock once you add this to your bank. You'll get an editable copy as a draft.</span>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose}>Close</Button>
        <Button variant="contained" disabled={importing} onClick={onAdd}>
          {importing ? "Adding…" : has ? "Update my copy" : "Add to my bank"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
